/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@express-labs/raven-ui';

import s from './MegaMenuListItem.module.scss';
import { analyze } from '../../../../../../helpers';

function MegaMenuListItem({
  children,
  className,
  linkLevel,
  role = 'menuitem',
  url,
  ...filteredProps
}) {
  const Element = url ? Link : 'span';
  const handleClick = () => {
    analyze({
      name: 'headerNavLinkClicked',
      data: {
        navLink: children,
      },
    });
  };

  return (
    <Element
      className={className || s.menuItem}
      href={url}
      role={role}
      data-link-level={linkLevel}
      {...filteredProps}
      onClick={handleClick}
    >
      {children}
    </Element>
  );
}

MegaMenuListItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  linkLevel: PropTypes.number,
  role: PropTypes.string,
  url: PropTypes.string,
};

export default MegaMenuListItem;
